import React, { useRef, useState } from "react";
import {
  TrashIcon,
  EllipsisHorizontalCircleIcon,
} from "@heroicons/react/24/solid";
import Whatsapp from "../../../../assets/Icons/icons8-whatsapp (1).svg";
const DetailsCartRow = ({ details, onDelete, onEdit, onDetails }) => {
  const [showValue, setShowValue] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleValue = () => {
    setShowValue((prev) => !prev);
  };
  const values = [
    details.number,
    details.boxNumber,
    details.Name,
    details.phone,
    details.status,
    // details.note,
    details.history ? new Date(details.history).toISOString().slice(5, 10) : "",
  ];

  // console.log(details.history)
  return (
    <tr className="text-sm text-center text-gray-800 bg-white">
      {values.map((value, index) => (
        <td key={index} className="px-2 py-2 ">
          {index === 3 ? (
            <span className="flex items-center justify-center gap-4 text-black test-sm">
              {details.countryCode + value}
              <a href={`tel:${details.countryCode + value}`} className="">
                <img src={Whatsapp} className="w-7" />
              </a>
            </span>
          ) : index === 10 ? (
            <>
              <div className="relative inline-block ">
                <span
                  onClick={toggleValue}
                  ref={buttonRef}
                  className="flex px-2 py-2 text-xs text-black cursor-pointer bg-custom-yellow"
                >
                  Show Info
                </span>

                {showValue && value && (
                  <div
                    className="absolute z-50 w-[500px] px-2 py-1 mt-2 text-sm bg-white border rounded shadow "
                    ref={dropdownRef}
                  >
                    {value}
                  </div>
                )}
              </div>
            </>
          ) : index === 6 && details.history ? (
            <div className="flex flex-col">
              <span className="text-black">
                {new Date(details.history).toISOString().slice(5, 10)}
              </span>
              <span className="text-black">
                {new Date(details.history).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                  timeZone: "Asia/Kuwait",
                })}
              </span>
            </div>
          ) : (
            value
          )}
        </td>
      ))}
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          <button onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button>
        </div>
      </td>
      <td className="px-2 py-2">
        <div className="flex justify-around space-x-2">
          <button onClick={onDetails}>
            <EllipsisHorizontalCircleIcon className="bg-black rounded-full text-custom-yellow w-7" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default DetailsCartRow;
